import * as React from 'react';
import * as styles from './BetInput.css';
import { AddStroke16 } from '@cian/ui-kit';
import { MinusIcon } from './icons/MinusIcon';
import classNames from 'classnames';
import { Spinner } from '../../../common/Spinner';

export interface IBetInputProps {
  value: string;
  loading: boolean;
  previousDisabled: boolean;
  nextDisabled: boolean;
  onChange(value: string): void;
  onPreviousClick(): void;
  onNextClick(): void;
}

export const BetInput = (props: IBetInputProps) => {
  const { value, loading, previousDisabled, nextDisabled, onChange, onPreviousClick, onNextClick } = props;

  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.value);
    },
    [onChange],
  );

  return (
    <div className={classNames(styles['wrapper'], loading && styles['loading'])}>
      <button
        type="button"
        data-name="BetMinusButton"
        disabled={previousDisabled}
        onClick={onPreviousClick}
        className={classNames(styles['button'], styles['previous'])}
      >
        <MinusIcon />
      </button>

      <input
        type="number"
        data-name="BetInput"
        pattern="[0-9]*"
        inputMode="numeric"
        value={value}
        placeholder="Введите ставку"
        className={styles['input']}
        onChange={handleChange}
      />

      {loading && (
        <div className={styles['spinner_wrapper']}>
          <Spinner />
        </div>
      )}

      <button
        type="button"
        data-name="BetPlusButton"
        disabled={nextDisabled}
        onClick={onNextClick}
        className={classNames(styles['button'], styles['next'])}
      >
        <AddStroke16 color="current_color" />
      </button>
    </div>
  );
};
